export default {
  ACCESS_TOKEN_KEY: process.env.VUE_APP_ACCESS_TOKEN_KEY,
  DATE_FORMAT: 'YYYY-MM-DD',
  FULL_DATE_TIME: 'DD-MM-YYYY h:mm:ss A',
  MOBILE_FORMAT: 'NATIONAL',
  DAY_TIME_FORMAT: 'LLLL',
  DATE_TIME_FORMAT: 'MM/DD h:mm',
  DAY_OF_MONTH_FORMAT: 'MMMM Do YYYY',
  MONTH_FIRST_DATE_FORMAT:'MMMM DD, YYYY',
  DEFAULT_ROUTE_PATH: {
    ADMIN: 'patient.index',
    CARE_AUTHOR: 'careplan.index',
    CARE_NAVIGATOR: 'patientProgress.index',
    FIRST_RESPONDER: 'followUpPatientList.index'
  },
  SCROLL_TYPE_HISTORY: 'history'
};
